import { Link, useNavigate } from 'react-router';

import routes from '@/assets/constants/routes-no.ts';
import { EconomySection } from '@/components/marketing/economy-section/index.ts';
import { SplitHeroSection } from '@/components/marketing/split-hero-section/index.ts';
import Page from '@/components/Page/index.ts';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import { useAuth } from '@/services/Auth/index.ts';
import { Button } from '@/ui/button-2.tsx';

import { DiagramSection } from './internal/diagram-section.tsx';
import smartphoneSrc from './internal/smartphone.svg';

export default function CreditCheck() {
  const { login, isAnonymous } = useAuth();
  const navigate = useNavigate();

  const destination = `${routes.MY_SCOOPR_DASHBOARD}?from=credit-check`;

  const loginAction = async () => {
    sendUserPortalEvent('main_cta_clicked');
    if (isAnonymous) {
      await login('SCRIVE', destination);
    } else {
      await navigate(destination);
    }
  };

  return (
    <Page title="Kredittsjekk">
      <div className="flex w-full flex-col bg-white">
        <article className="flex flex-col gap-8 sm:gap-15 md:mt-15">
          <SplitHeroSection.Root>
            <SplitHeroSection.Content>
              <SplitHeroSection.Title>Ta en gratis kredittsjekk</SplitHeroSection.Title>

              <p className="mb-4 text-center typography-v1-h3 text-balance md:mb-6 lg:mb-8">
                Med Scoopr er det lettere enn noen gang å få oversikt over egen økonomi
              </p>

              <SplitHeroSection.List>
                <SplitHeroSection.ListItem>
                  Få full oversikt over din egen kredittscore – helt på egenhånd
                </SplitHeroSection.ListItem>
                <SplitHeroSection.ListItem>
                  Oppdag feil eller uregistrerte betalingsanmerkninger
                </SplitHeroSection.ListItem>
                <SplitHeroSection.ListItem>
                  Forbered deg til du skal søke lån eller refinansiering
                </SplitHeroSection.ListItem>
              </SplitHeroSection.List>

              <Button color="yellow" className="mb-4 md:mb-6 lg:mb-8" action={loginAction}>
                Logg på med BankID
              </Button>

              <p className="max-w-md text-center typography-v1-body3">
                Ved å fortsette aksepterer jeg Scoopr sine{' '}
                <Link
                  to={routes.TERMS_OF_USE_MIN_SCOOPR}
                  className="text-[#18A0FB] hover:underline"
                >
                  brukervilkår
                </Link>{' '}
                og{' '}
                <Link to={routes.PRIVACY_STATEMENT} className="text-[#18A0FB] hover:underline">
                  personvernerklæring
                </Link>
              </p>
            </SplitHeroSection.Content>

            <SplitHeroSection.ImageContainer>
              <SplitHeroSection.Image
                src={smartphoneSrc}
                width={220}
                height={250}
                alt="credit check on smartphone"
              />
            </SplitHeroSection.ImageContainer>
          </SplitHeroSection.Root>
          <DiagramSection action={loginAction} />
          <EconomySection />
        </article>
      </div>
    </Page>
  );
}
